export interface GetReportInformationResponse {
    name: string;
    version: string;
    status: "OK";
}
